import { TextField, Typography, styled } from "@mui/material"

export const StyledTextLabel = styled(Typography)`
  color: #fff;
  font-size: 16px;
`

export const StyledDateField = styled(TextField)`
  color: #fff;

  & .MuiInputBase-root {
    color: #fff;
  }
`